// Single source of truth for the mock-fallback gate.
//
// The user-search / contacts / call-history clients all degrade
// gracefully when the BE returns 404/501 — in **mock mode** they
// return a deterministic fixture so the UI is exercisable without a
// running server, in **prod mode** they return an empty result so the
// UI surfaces its empty state.
//
// Set `VITE_WITH_MOCK=true` in the environment (or `.env.local`) to
// turn the fixture path on. Default is OFF, even in dev — that way
// the dev build hits the real BE by default and only opts into mocks
// when explicitly requested.
//
// Vite inlines `import.meta.env.VITE_*` at build time, so this guard
// is tree-shaken in builds where the flag is unset.

export const WITH_MOCK: boolean =
  String(import.meta.env.VITE_WITH_MOCK ?? '').toLowerCase() === 'true';
